// Libraries:
import React from "react";
import PropTypes from "prop-types";

// Components:
import SectionContainer from "core/SectionContainer";
import BodyText from "core/BodyText";
import ItemsDisplay from "./ItemsDisplay";

// Styles:
import { Grid, Row, Col } from "core/grid";
import Flexbox from "core/Flexbox";
import colors from "core/colors";
import {
    MoreFromThisTextWrapper,
    RowHeading,
    ViewAllLink,
    ImageRowWrapper,
    ImageRow
} from "./styles";

// Component:
const MoreFromThis = ({ items, heading, viewAllLink, eachDataTestId }) => {
    // if no items, return empty component so we dont need a flag in the parent component:
    if (!items || (Array.isArray(items) && items.length === 0)) {
        return null;
    }

    return (
        <SectionContainer
            topSpacing="xl"
            bottomSpacing="xl"
            bgColor={colors.mist}
        >
            <Grid>
                <Row>
                    <Col sm={12}>
                        <Flexbox alignItems="flex-start">
                            <MoreFromThisTextWrapper>
                                <RowHeading
                                    type="div"
                                    size="sm"
                                    copyColor={colors.midnight}
                                >
                                    {heading}
                                </RowHeading>
                                <BodyText type="div" size="sm">
                                    <ViewAllLink to={viewAllLink}>
                                        View All
                                    </ViewAllLink>
                                </BodyText>
                            </MoreFromThisTextWrapper>
                            <ImageRowWrapper>
                                <ImageRow>
                                    <ItemsDisplay
                                        items={items}
                                        eachDataTestId={eachDataTestId}
                                    />
                                </ImageRow>
                            </ImageRowWrapper>
                        </Flexbox>
                    </Col>
                </Row>
            </Grid>
        </SectionContainer>
    );
};

MoreFromThis.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            itemId: PropTypes.string.isRequired,
            itemTitle: PropTypes.string.isRequired,
            itemImage: PropTypes.string.isRequired
        })
    ),
    heading: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
        .isRequired,
    viewAllLink: PropTypes.string.isRequired,
    eachDataTestId: PropTypes.string
};

export default MoreFromThis;
